module.exports = __webpack_public_path__ + "static/media/default_User_Icon_Women.5a99c620.png";